import { HiHandThumbUp } from "react-icons/hi2";

export const RecommendationIcon = ({ width, height, color, ...props }) => (
  <HiHandThumbUp
    size={width || height || 12}
    color={color || "currentColor"}
    {...props}
  />
);
